type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[]
};

declare const window: WindowWithDataLayer;

/* eslint-disable */
export default (containerId: string) => {
  window['dataLayer'] = window['dataLayer'] || [];
  window['dataLayer'].push({
    'gtm.start':
      new Date().getTime(),
    event: 'gtm.js'
  });
  const f = document.getElementsByTagName('script')[0],
    j = document.createElement('script'),
    dl = 'dataLayer' != 'dataLayer' ? '&l=dataLayer' : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + containerId + dl;
  f.parentNode?.insertBefore(j, f);
};
